import { type CyberAssessmentCreateDto, TechnologyType } from '@@types/api.types';
import { z } from 'zod/v4';

export const cyberAssessmentCreateSourceAssessmentIdSchema = z
  .string({ error: 'Military TRL source is required' })
  .min(1, { message: 'Military TRL source is required' });

export const cyberAssessmentCreateTechnologyTypeSchema = z.union([
  z.literal(TechnologyType.HARDWARE),
  z.literal(TechnologyType.HYBRID),
  z.literal(TechnologyType.SOFTWARE),
]);

export const cyberAssessmentCreateTechnologyTypesSchema = z
  .array(cyberAssessmentCreateTechnologyTypeSchema, {
    error: 'Select at least one technology type',
  })
  .min(1, { message: 'Select at least one technology type' });

export const cyberAssessmentCreateSchema = z.object({
  sourceAssessmentId: cyberAssessmentCreateSourceAssessmentIdSchema,
  technologyTypes: cyberAssessmentCreateTechnologyTypesSchema,
}) as z.ZodType<CyberAssessmentCreateDto>;

export type CyberAssessmentCreateFormData = z.infer<typeof cyberAssessmentCreateSchema>;
